export default __webpack_public_path__ + "static/media/home.0b2fd4ce.svg";